<div class="container">
  <div [formGroup]="expectationForm()" class="expectation-item">
    <div class="row row-content">
      <div class="item">
        <div class="circle">{{ index() }}</div>
      </div>
      <div class="fields" [class.view-mode]="isReadOnly()">
        <div class="item">
          <app-input-select
            class="large no-padding-bottom"
            [enableViewMode]="isReadOnly()"
            [options]="pathPrefixOptions"
            [placeholder]="translations.pathPrefix"
            [copyMode]="copyMode"
            formControlName="pathPrefix"
          ></app-input-select>
        </div>
        <div class="item">
          <app-input-select
            class="large no-padding-bottom"
            [enableViewMode]="isReadOnly()"
            [options]="pathSuffixOptions"
            [placeholder]="translations.pathSuffix"
            [copyMode]="copyMode"
            formControlName="pathSuffix"
          ></app-input-select>
        </div>
        <div class="item">
          <app-input-select
            emitRawValue
            class="large no-padding-bottom"
            [enableViewMode]="isReadOnly()"
            [options]="operatorOptions()"
            [placeholder]="translations.operator"
            [copyMode]="copyMode"
            formControlName="operator"
          ></app-input-select>
        </div>
        <div class="item">
          @if (isEqOperator()) {
            <app-input-select
              [addOnWrite]="true"
              class="large no-padding-bottom"
              [enableViewMode]="isReadOnly()"
              [options]="valueOptions()"
              [placeholder]="translations.selectValue"
              formControlName="value"
            ></app-input-select>
          } @else {
            <app-input-chips
              allowCreateTag
              (tagCreatedEvent)="onNewDocumentTypeCreated($event)"
              class="no-padding-bottom tags-container-no-padding-top"
              [enableViewMode]="isReadOnly()"
              [tagUrl]="documentTypesService.baseUrl"
              [options]="valueOptions()"
              [placeholder]="translations.value"
              formControlName="value"
            ></app-input-chips>
          }
        </div>
      </div>
      @if (shouldDisplayDeleteButton()) {
        <div class="item">
          <app-button
            type="icon"
            class="large"
            [tp]="translations.deleteTp"
            [tpIsLazy]="true"
            (pressed)="onRemove()"
          >
            <mat-icon>delete</mat-icon>
          </app-button>
        </div>
      }
    </div>
  </div>
</div>
